import React from 'react'
import { Card, CardMedia, CardContent, Button, Typography, Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import { Course as ICourse } from '../../../../types/academy'
import { isNew } from '../../../utils/academy'
import Image from 'next/image'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '16px 0',
    minHeight: '24rem',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  text: {
    color: theme.palette.primary.main,
  },
  image: {
    width: '100%',
    height: 'inherit',
    position: 'relative',
    borderRadius: '4px',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
  },
  content: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  chip: {
    padding: '4px',
    width: 'fit-content',
  },
  subtitle: {
    fontSize: '16px',
  },
  button: {
    width: 'fit-content',
    background: '#895DD1',
    height: 'unset',
    borderRadius: 8,
    padding: '8px 24px',
    fontFamily: theme.typography.fontFamily,
    textTransform: 'none',
    fontWeight: 'normal',
  },
  actionArea: {
    '&:hover $focusHighlight': {
      opacity: 0,
    },
  },
  focusHighlight: {},
}))

interface Props {
  course: ICourse
}

function FeaturedCard({ course }: Props): JSX.Element {
  const classes = useStyles({})
  const { image, title, description, createdAt } = course
  const lessonURl =
    course.lessons.length > 1 ? `/courses/${course.slug}/lesson/${course?.lessons[0]?.slug}` : '#'

  return (
    <Card elevation={0} className={classes.root}>
      <div className={classes.image}>
        <Image layout="fill" objectFit="cover" src={image?.url} />
      </div>
      <CardContent className={classes.content}>
        {isNew(new Date(createdAt)) ? (
          <Chip label="New" color="primary" size="small" className={classes.chip} />
        ) : null}
        <Typography variant="h3">{title}</Typography>
        <Typography color="textSecondary" className={classes.subtitle}>
          {description}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.button}
          endIcon={<ArrowForwardIcon />}
          href={lessonURl}
        >
          Start Course
        </Button>
      </CardContent>
    </Card>
  )
}

export default FeaturedCard
